export default __webpack_public_path__ + "static/media/image1.44b5f8d0.jpg";